// extracted by mini-css-extract-plugin
module.exports = {"info":"info__biVaMoZ2Nmv0w","icon":"icon__1dO1Nrs2k97bL","closeIcon":"closeIcon__OTaoMZudEXv1q"};